<template>
  <div>
    <h1 :style="{color: color}">{{msg}}</h1>
    <!-- <img src="@/assets/logo.png" /> -->
    <img src="../../assets/logo.png" alt="">
    <el-button type="primary">主要按钮</el-button>
    <el-switch
      v-model="vSwitch"
      active-color="#13ce66"
      inactive-color="#ff4949">
    </el-switch>
  </div>
</template>

<script>
export default {
  name: 'moorHelloWorld',
  props: {
    color: {
      type: String,
      default: 'pink'
    },
    msg: {
      type: String,
      default: 'Hello World!'
    }
  },
  data() {
    return {
      vSwitch:''
    }
  }
}
</script>

<style lang="scss">

</style>


